console.log("[socket.js] loaded");

// -----------------------------
// 1) WebSocket 인스턴스 관리
// -----------------------------
let wsAruco = null;
let wsChat = null;

// 각각의 연결 상태
let connectingAruco = false;
let connectingChat = false;

// 이벤트 핸들러 저장
const handlersAruco = { message: null, open: null, close: null, error: null };
const handlersChat = { message: null, open: null, close: null, error: null };


// ==========================================================
// 2) ArUco WebSocket 연결 (기존 기능 유지)
// ==========================================================
export function connectArUcoWS(urlOverride) {
  if (
    wsAruco &&
    (wsAruco.readyState === WebSocket.OPEN || wsAruco.readyState === WebSocket.CONNECTING)
    || connectingAruco
  ) return wsAruco;

  connectingAruco = true;

  const url = urlOverride || `${location.origin.replace("http", "ws")}/ws-aruco`;
  console.log("[socket.js] connecting to (ArUco)", url);

  wsAruco = new WebSocket(url);

  wsAruco.onopen = (e) => {
    connectingAruco = false;
    handlersAruco.open?.(e);
  };

  wsAruco.onmessage = (e) => {
    try { handlersAruco.message?.(JSON.parse(e.data)); }
    catch { handlersAruco.message?.(e.data); }
  };

  wsAruco.onerror = (e) => handlersAruco.error?.(e);

  wsAruco.onclose = (e) => {
    connectingAruco = false;
    handlersAruco.close?.(e);
    wsAruco = null;
  };

  return wsAruco;
}

export function sendArucoJSON(obj) {
  if (wsAruco && wsAruco.readyState === WebSocket.OPEN)
    wsAruco.send(JSON.stringify(obj));
}

export function onArucoWS(event, cb) {
  handlersAruco[event] = cb;
}


// ==========================================================
// 3) Chat WebSocket 연결 (새 WebSocket)
// ==========================================================
export function connectChatWS(urlOverride) {
  if (
    wsChat &&
    (wsChat.readyState === WebSocket.OPEN || wsChat.readyState === WebSocket.CONNECTING)
    || connectingChat
  ) return wsChat;

  connectingChat = true;

  const url = urlOverride || `${location.origin.replace("http", "ws")}/ws/file_list`;
  console.log("[socket.js] connecting to (Chat)", url);

  wsChat = new WebSocket(url);

  wsChat.onopen = (e) => {
    connectingChat = false;
    handlersChat.open?.(e);
  };

  wsChat.onmessage = (e) => {
    try { handlersChat.message?.(JSON.parse(e.data)); }
    catch { handlersChat.message?.(e.data); }
  };

  wsChat.onerror = (e) => handlersChat.error?.(e);

  wsChat.onclose = (e) => {
    connectingChat = false;
    handlersChat.close?.(e);
    wsChat = null;
  };

  return wsChat;
}

export function sendChatJSON(obj) {
  if (wsChat && wsChat.readyState === WebSocket.OPEN)
    wsChat.send(JSON.stringify(obj));
}

export function onChatWS(event, cb) {
  handlersChat[event] = cb;
}


// ==========================================================
// 4) 전체 제어
// ==========================================================
export function disconnectAllWS() {
  try { wsAruco?.close(1000, "manual close"); } catch {}
  try { wsChat?.close(1000, "manual close"); } catch {}
  wsAruco = null;
  wsChat = null;
}

export function isChatOpen() {
  return wsChat && wsChat.readyState === WebSocket.OPEN;
}

export function isArucoOpen() {
  return wsAruco && wsAruco.readyState === WebSocket.OPEN;
}

console.log('[socket.js] loaded');

let ws = null;
let connecting = false;
const handlers = { message: null, open: null, close: null, error: null };

export function connectWS(urlOverride) {
  if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) || connecting) return ws;
  connecting = true;

  const url = urlOverride || `${location.origin.replace('http', 'ws')}/ws-aruco`; // ← 프록시 경로 사용
  console.log('[socket.js] connecting to', url);
  ws = new WebSocket(url);

  ws.onopen = (e) => {
    connecting = false;
    handlers.open?.(e);
  };

  ws.onmessage = (e) => {
    try { handlers.message?.(JSON.parse(e.data)); }
    catch { handlers.message?.(e.data); }
  };

  ws.onerror = (e) => {
    handlers.error?.(e);
  };

  ws.onclose = (e) => {
    connecting = false;
    handlers.close?.(e);
    ws = null; // 수동 모드: 자동 재연결 안 함
  };

  return ws;
}

export function disconnectWS() {
  if (ws) {
    try { ws.close(1000, 'manual close'); } catch {}
    ws = null;
  }
}

export function onWS(event, cb) { handlers[event] = cb; }
export function sendJSON(obj) { if (ws && ws.readyState === WebSocket.OPEN) ws.send(JSON.stringify(obj)); }
export function isOpen() { return ws && ws.readyState === WebSocket.OPEN; }
